import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/karina/vo/ApiResultVo.interface';
import type {DayOfWeekListVo} from '../../common/shared/api/karina/vo/dayOfWeek/DayOfWeekListVo.interface';

/**
 * 요일연재 List 조회
 *
 * Origin: pageKarinaApi.getDayOfWeekList
 * API: GET /v1/list/dayofweek
 */
export async function getTabListDayOfWeek(
  params: {
    referenceKey: string;
    dayUid?: number;
    hasBanner?: boolean;
    sortType?: string;
    page?: number;
    size?: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo<DayOfWeekListVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/view/v1/list/dayofweek',
    {
      method: 'GET',
      params: {
        reference_key: params.referenceKey,
        day_uid: params.dayUid,
        has_banner: params.hasBanner,
        sort_type: params.sortType,
        page: params.page,
        size: params.size,
      },
    },
    options
  );
  return response.data;
}
